{{#each appendedDeclarationPartials}}
{{> (partial .) ..}}

{{/each}}
